import {getAuthToken, isAuthenticated, verifyAuth} from '../../auth';
import {loadContentForElement, loadContentForElements} from './content-loader';
import {applyContentToElement} from './content-renderer';
import {
    cleanupEventHandlers,
    setupDocumentDownloadHandlers,
    setupEditableElements,
    setupEditButton
} from './element-setup';
import {addPublishButton} from './publish-manager';


const editorState = {
    isInitialized: false,
    isAuthenticating: false,
    isEditorActive: false
};

export function initContentEditor() {
    if (editorState.isInitialized) {
        cleanupEditor();
    }

    const authStatusElement = document.getElementById('auth-status');
    if (authStatusElement) {
        authStatusElement.innerHTML = '';
    }

    loadContent();

    if (isAuthenticated()) {
        initEditorForAuthenticatedUser();
    }

    editorState.isInitialized = true;

    return {
        loadContentForNewElements,
        cleanupEditor
    };
}

async function loadContent() {
    try {
        const contentElements = document.querySelectorAll('[data-content]');

        for (const element of contentElements) {
            const pageTitle = element.getAttribute('data-page') || 'Home';
            const tagId = element.getAttribute('data-content');
            const isGlobal = element.getAttribute('data-global') === 'true';

            element.classList.add('content-loading');

            const data = await loadContentForElement(element, pageTitle, tagId, isGlobal);

            element.classList.remove('content-loading');

            if (data) {
                applyContentToElement(element, data);
            }
        }

        setupDocumentDownloadHandlers();

    } catch (error) {
        console.error('Error loading content:', error);
    }
}

function initEditorForAuthenticatedUser() {
    editorState.isAuthenticating = true;

    verifyAuth(getAuthToken())
        .then(() => {
            setupEditableElements();
            addPublishButton();

            editorState.isEditorActive = true;
            editorState.isAuthenticating = false;
        })
        .catch(error => {
            console.error('Authentication failed:', error);
            localStorage.removeItem('token');
            editorState.isAuthenticating = false;
        });
}

export function loadContentForNewElements(elements) {
    loadContentForElements(elements)
        .then(results => {
            elements.forEach((element, index) => {
                applyContentToElement(element, results[index]);
            });

            if (!isAuthenticated()) return;

            if (editorState.isEditorActive) {
                elements.forEach(setupEditButton);
            } else if (editorState.isAuthenticating) {
                // verifyAuth still in progress — retry once it completes
                const retry = setInterval(() => {
                    if (editorState.isEditorActive) {
                        clearInterval(retry);
                        elements.forEach(setupEditButton);
                    } else if (!editorState.isAuthenticating) {
                        clearInterval(retry);
                    }
                }, 50);
                setTimeout(() => clearInterval(retry), 5000);
            }
        })
        .catch(error => {
            console.error('Error loading content for new elements:', error);
        });
}

export function cleanupEditor() {
    cleanupEventHandlers();
    editorState.isEditorActive = false;
}